import api from './api'

export type MapsKeySource = 'environment' | 'database' | 'none'

export type MapsProbeLeg = {
  configured: boolean
  ok: boolean | null
  message: string | null
  apis?: MapsApiCheck[]
}

/** One Google API the server actually calls, tested on its own. */
export type MapsApiCheck = {
  api: string
  slug: string
  ok: boolean
  /** False for an API the platform can work without — e.g. the legacy fallback. */
  required: boolean
  message: string
  /** What stops working when this one is unavailable. */
  feature: string
  /** The exact Cloud console change that fixes it, when there is one. */
  remedy: string | null
}

export type MapsProbe = {
  ok: boolean
  error: string | null
  hint?: string | null
  browser?: MapsProbeLeg
  server?: MapsProbeLeg
  apis?: MapsApiCheck[]
}

export type MapsConfig = {
  configured: boolean
  apiKey: string | null
  keySource: MapsKeySource
  serverConfigured?: boolean
  serverKeySource?: MapsKeySource
  /**
   * Whether the Property map may ask the USGS for aerial imagery (the server's
   * AERIAL_IMAGERY_ENABLED kill switch). Only a literal `true` allows it.
   */
  aerialEnabled?: boolean
  probe?: MapsProbe
}

export const mapsConfigService = {
  get: () => api.get('/settings/maps-config').then((r) => r.data as MapsConfig),
  probe: () =>
    api.get('/settings/maps-config', { params: { probe: true } }).then((r) => r.data as MapsConfig),
}
